import React, { FC } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Icon } from "../Component"; // Assuming this path is correct
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Button, // Import Button from reactstrap
} from "reactstrap";
import { Breadcrumb, Dropdown, Space, Typography } from "antd";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import SearchInput from "../../pages/form-components/SearchComponent";
import { AddAccess } from "../accessControl/AccessControl";
import Export from "../export/Export";

const { Text } = Typography;

interface GroupByOption {
  key: string;
  label: string;
}

interface TimeSheetsHeaderProps {
  projectName: string;
  listViewType: string;
  setListViewType: (type: string) => void;
  groupBy: string;
  setGroupBy: (group: string) => void;
  groupByOptions: GroupByOption[];
  getLabel: (list: GroupByOption[], key: string) => string;
  // New props for the "Add Time Log" button
  showAddTimeLogButton?: boolean; // Optional prop to control visibility
  onAddTimeLogClick?: () => void; // Optional function to handle click
  searchQuery?: string | null;
  onSearchChange?: (value: string) => void;
  refreshData: () => void;
  projectId?: number;
}

const TimeSheetsHeader: FC<TimeSheetsHeaderProps> = ({
  projectName,
  listViewType,
  setListViewType,
  groupBy,
  setGroupBy,
  groupByOptions,
  getLabel,
  showAddTimeLogButton = false, // Default to false
  onAddTimeLogClick,
  searchQuery,
  onSearchChange,
  refreshData,
  projectId,
}) => {
  const methods = useForm({
    mode: "onChange",
  });

  const groupByMenu = {
    items: groupByOptions.map((item) => ({
      key: item.key,
      label: item.label,
      onClick: () => setGroupBy(item.key),
    })),
  };

  return (
    <>
      <FormProvider {...methods}>
        <form>
          <div
            className="nk-ibx-head p-0 m-0 mt-1 w-100 d-flex justify-content-between align-items-center"
            style={{ minHeight: "40px", border: "0px" }}
          >
            <div className="nk-ibx-head-actions w-45 ms-1">
              <div className="nk-ibx-head-tools g-1 m-0 p-0 w-100 ">
                <div className={`w-100 m-0 `}>
                  <SearchInput
                    name="search"
                    placeholder="Search..."
                    width="100%"
                    prefixIcon={<SearchOutlined />}
                    defaultValue={searchQuery || ""}
                    onDebouncedSearch={(value: string) => {
                      if (onSearchChange) {
                        onSearchChange(value);
                      }
                    }}
                    debounceDelay={300}
                  />
                </div>
              </div>
            </div>

            {/* Right section: Icons and Add Time Log Button */}
            <ul className="nk-ibx-head-tools g-1 m-0 p-0 d-flex align-items-center">
              {" "}
              {/* <li>
                <UncontrolledDropdown>
                  <DropdownToggle
                    tag="a"
                    className="dropdown-toggle btn btn-icon btn-trigger"
                  >
                    <Icon name="more-v"></Icon>
                  </DropdownToggle>
                  <DropdownMenu end>
                    <ul className="link-list-opt no-bdr">
                      <li
                        aria-disabled
                        className={listViewType === "list" ? "active" : ""}
                      >
                        <DropdownItem
                          tag="a"
                          href="#listView"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setListViewType("list");
                          }}
                        >
                          <span>List</span>
                        </DropdownItem>
                      </li>
                      <li className={listViewType === "grid" ? "active" : ""}>
                        <DropdownItem
                          tag="a"
                          href="#gridView"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setListViewType("grid");
                          }}
                        >
                          <span>Grid</span>
                        </DropdownItem>
                      </li>
                      <li
                        className={listViewType === "Calendar" ? "active" : ""}
                      >
                        <DropdownItem
                          tag="a"
                          href="#CalendarView"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setListViewType("Calendar");
                          }}
                        >
                          <span>Calendar View</span>
                        </DropdownItem>
                      </li>
                      <li
                        className={
                          listViewType === "fullCalenderView" ? "active" : ""
                        }
                      ></li>
                    </ul>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li> */}
              <li>
                <UncontrolledDropdown>
                  <DropdownToggle
                    tag="a"
                    className="dropdown-toggle btn btn-icon btn-trigger"
                    onClick={(ev) => {
                      ev.preventDefault();
                      refreshData();
                    }}
                  >
                    <Icon name="redo"></Icon>
                  </DropdownToggle>
                </UncontrolledDropdown>
              </li>
              <li>
                <Export
                  data={{
                    sortOrder: "DESC",
                    pageSize: 100,
                    direction: "P",
                    pageDiff: 0,
                    searchQuery,
                    projectIds: projectId ? projectId.toString() : undefined
                    // ...getExportFilters(),
                    // selectFilter1,
                    // selectFilter2,
                    // selectFilter3,
                    // dateRange: dateRange && convertToDates(dateRange),
                    // customDateRange,
                  }}
                  moduleKey={window.location.pathname}
                  showAsButton={true}
                />
              </li>
              {/* Add the "Add Time Log" button conditionally here */}
              {showAddTimeLogButton && (
                <li>
                  <AddAccess moduleName="Projects">
                    <Button
                      color="primary"
                      size="md"
                      onClick={onAddTimeLogClick} // Use the passed function
                      style={{ marginRight: "12px" }}
                    >
                      <Icon name="plus" />
                      <span>Add Time Log</span>
                    </Button>
                  </AddAccess>
                </li>
              )}
            </ul>
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default TimeSheetsHeader;
